export enum StatusCode {
  ServerError = 500,
  NoStatus = 0,
  BadRequest = 400,
  UnAuthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  NotAcceptable = 406,
  OK = 200,
  Created = 201,
  Accepted = 202,
  Ambiguous = 300
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/api/status-codes.enum.ts